import React from "react";
import { isFullArray } from "@obby/lib";
import { Box, Img, Text } from "./ThreePointSalesBanner.layout";

export function ThreePointSalesBanner({ size, color, title, points }) {
  return (
    <Box
      className="three-point-sales-banner"
      componentname="three-point-sales-banner"
      variant="salesBanner"
      size={size}
      css={{ backgroundColor: color }}
    >
      <Box variant="section">
        {title && (
          <Text
            variant="title"
            className="three-point-sales-banner__title"
            componentname="three-point-sales-banner__title"
          >
            {title}
          </Text>
        )}
        {isFullArray(points) && (
          <Box
            variant="points"
            className="three-point-sales-banner__points"
            componentname="three-point-sales-banner__points"
          >
            {points.map((point, index) => (
              <Box
                key={index}
                variant="item"
                className="three-point-sales-banner__item"
                componentname="three-point-sales-banner__item"
              >
                <Box
                  variant="itemImage"
                  className="three-point-sales-banner__item-image"
                  componentname="three-point-sales-banner__item-image"
                >
                  <Img alt={point.title} src={point.image} />
                </Box>
                <Box
                  variant="imageTitle"
                  className="three-point-sales-banner__item-title"
                  componentname="three-point-sales-banner__item-title"
                >
                  {point.title}
                </Box>
                <Box
                  variant="imageDescription"
                  componentname="three-point-sales-banner__item-description"
                  className="three-point-sales-banner__item-description"
                >
                  {point.description}
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}
